export default "/static/assets/4f4e7e5025c1c9de.png"